import { useEffect } from "react";
import { MYCORR_MARK } from "@/lib/mycorrMark";

/// The palette's colors are pastels that wash out on a light tab strip, so there the mark takes
/// the same hue at the lightness of the palette's dark-theme variants.
function inkOnLight(color: string): string {
  const hsl = color.match(
    /^hsl\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*[\d.]+%\s*\)$/,
  );
  return hsl ? `hsl(${hsl[1]}, ${hsl[2]}%, 42%)` : color;
}

function markHref(ink: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><path d="${MYCORR_MARK}" stroke="${ink}" stroke-width="4" stroke-linejoin="bevel"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/// The browser tab names what it shows and draws the mark in its color; both return to the app's
/// own when the caller unmounts or has nothing to show.
export function useTabIdentity(
  title: string | undefined,
  color: string | undefined,
): void {
  useEffect(() => {
    if (!title) return;
    const before = document.title;
    document.title = title;
    return () => {
      document.title = before;
    };
  }, [title]);

  useEffect(() => {
    if (!color) return;
    // index.html's icon links pick light or dark by their `media`, which the browser re-evaluates
    // when its scheme changes; each keeps its media and takes the mark in that scheme's ink.
    const links = [
      ...document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]'),
    ];
    const before = links.map((l) => ({ href: l.href, type: l.type }));
    for (const l of links) {
      l.href = markHref(l.media.includes("dark") ? color : inkOnLight(color));
      l.type = "image/svg+xml";
    }
    return () =>
      links.forEach((l, i) => {
        l.href = before[i].href;
        l.type = before[i].type;
      });
  }, [color]);
}
